module.exports = __webpack_public_path__ + "static/img/icon_js_iuser.c78d101d.png";